import Table from "@/components/Table/Table";
import styles from "@/pages/goods_and_services/GoodsAndServicesItemDetail/GoodsAndServicesItemDetail.module.scss";
import { useGetGoodsAndServicesItemRelationsPerYear } from "../useGoodsAndServices";

function GoodsAndServicesItemRelationsPerYear({
  goodsAndServicesItemId,
}: {
  goodsAndServicesItemId: number;
}) {
  const { data, isLoading, isFetching } = useGetGoodsAndServicesItemRelationsPerYear({
    goodsAndServicesItemId,
  });
  return (
    <div className={styles.relationPerYearContainer}>
      <Table
        loading={isLoading || isFetching}
        type="grey"
        emptyState={{ hide: true }}
        hideRaster={true}
        data={data}
        columns={[
          {
            label: "Year",
            key: "year",
            renderer: (record) => (!record.year ? "Unrelated" : record.year),
          },
          {
            label: "Facilities",
            key: "facility_count",
            renderer: (record) => record.facility_count,
          },
        ]}
        rowKey={"year"}
      />
    </div>
  );
}

export default GoodsAndServicesItemRelationsPerYear;
